<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height" />
  </div>
</template>
<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Colorize, palette} from "@/libs/colorizer";

export default {
  name: "5577e2fc-815f-11eb-811b-00155d01060e",
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  props: ['chart', 'size', 'title', 'uuid'],
  data() {
    return {
      no_sys: 'НЕИЗВЕСТНО',
      canvas: null,
      graph: null,
      objecto: null,
      sys_list: [],
      datasets: [],
      month_list: [],
      monthz: [],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
    }
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        let months = this.month_list
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.monthz,
            datasets: this.datasets,
          },
          options: {
            plugins: {
              legend: {
                display: true
              },
              datalabels: {
                anchor: 'center',
                clamp: true,
                align: 'center',
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor)
                },
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              },
              tooltip: {
                callbacks: {
                  title: function (value) {
                    let m = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
                    return 'Количество обращений за месяц ' + m[months[value[0].dataIndex]]
                  }
                }
              }
            },
            scales: {
              x: {
                stacked: true,
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function(index) {
                    let m = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
                    return m[months[index]];
                  }
                }
              },
              y: {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (Number.isInteger(value)) { return value } },
                  stepSize: 1
                },
                title: {
                  display: true,
                  text: 'Кол-во обращений'
                },
              }
            }
          }
        })
        this.graph.data.datasets.push()
      }
    },
    update_data: function () {
      this.objecto = null
      this.sys_list = []
      this.datasets = []
      this.month_list = []
      this.monthz = []

      for (let i = 0; i < this.chart.report_data.length;i ++) {
        if (!this.month_list.includes(new Date(this.chart.report_data[i]["Месяц"]).getMonth())) {
          // eslint-disable-next-line vue/no-mutating-props
          this.month_list.push(new Date(this.chart.report_data[i]["Месяц"]).getMonth())
          this.monthz.push({
            name: new Date(this.chart.report_data[i]["Месяц"]).getMonth(),
            systems: []
          })
        }
      }

      this.objecto = this.month_list
      let name_of_null = this.no_sys
      for (let i = 0; i < this.chart.report_data.length; i ++) {
        if (!this.sys_list.includes(this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]))) {
          if (this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]) {
            this.sys_list.push(this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]))
          } else {
            if (!this.sys_list.includes(name_of_null)) {
              this.sys_list.push(name_of_null)
            }
          }
        }
      }


      for (let i = 0; i < this.chart.report_data.length; i ++) {
        let element = (this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"] !== '') ? this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]) : name_of_null
        if (this.month_list.includes(new Date(this.chart.report_data[i]["Месяц"]).getMonth()) && this.sys_list.includes(element)) {
          this.monthz[this.month_list.indexOf(new Date(this.chart.report_data[i]["Месяц"]).getMonth())].systems.push({
            system_name: element,
            obrashens: get_count(this.chart.report_data, this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"], this.chart.report_data[i]["Месяц"])
          })
        }
      }

      function get_count(all, system, month) {
        let count = 0

        for (let line of all) {
          if (line['СервисПРЕДСТАВЛЕНИЕ'] === system && line["Месяц"] === month) {
            count += line['Обращения']
          }
        }
        return count
      }

      let data = []
      for (let i = 0; i < this.sys_list.length; i++) {
        let system_error_by_object = []
        for (let j = 0; j < this.monthz.length; j++) {
          system_error_by_object[j] = 0
        }
        data.push(system_error_by_object)
      }

      for (let i = 0; i < this.monthz.length; i++) {
        for (let j = 0; j < this.monthz[i].systems.length; j++) {
          data[this.sys_list.indexOf(this.monthz[i].systems[j].system_name)][i] = this.monthz[i].systems[j].obrashens
        }
      }

      for (let i = 0; i < this.sys_list.length; i++) {
        this.datasets.push(
            {
              label: this.sys_list[i],
              data: data[i],
              maxBarThickness: 800,
            }
        )
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    },
    shorten_src: function (name) {
      return name.split(' - ')[0]
    }
  }
}
</script>

<style scoped>
</style>
